window.onload = () => {
	//
	// désactivation de l'action des liens ne contenant qu'une ancre
	//
	document.querySelectorAll('a[href="#"]').forEach((el) => {
		el.addEventListener('click', (event) => {
			event.preventDefault();
		})
	});

	//
	// réécriture des e-mails
	//
	document.querySelectorAll('.obfsclk').forEach((el) => {
		el.innerHTML = el.innerHTML.replace(new RegExp('{AT}', 'g'), '@').replace(new RegExp('{DOT}', 'g'), '.');
		el.classList.remove('d-none');
	});

	//
	// affichage du bouton pour retourner en haut de page
	//
	if(document.querySelector('.scrollto')) {
		var prevScrollpos = window.pageYOffset;

		window.onscroll = function() {
			if(window.outerHeight >= 356) {
				var currentScrollPos = window.pageYOffset;

				let scrollto = document.querySelector('.scrollto');

				if(scrollto) {
					if(prevScrollpos <= currentScrollPos || currentScrollPos <= 0) {
						scrollto.classList.remove('bottom-4');
					} else {
						scrollto.classList.add('bottom-4');
					}
				}

				prevScrollpos = currentScrollPos;
			}
		}
	}

	//
	// placement du bouton pour retourner en haut de page
	//
	function displayRetour() {
		if(document.querySelector('.scrollto') && document.querySelector('body > div.mx-auto')) {
			let scrollTo = document.querySelector('.scrollto');

			if(scrollTo) {
				let marginLeft = document.querySelector('body > div.mx-auto').offsetWidth - scrollTo.offsetWidth.toFixed(0);

				scrollTo.style.marginLeft = marginLeft + 'px';
				scrollTo.classList.remove('opacity-0');
			}
		}
	}

	displayRetour();

	addEventListener('resize', () => {
		displayRetour();
	});

	//
	// ajout de la balise title aux liens qui s'ouvrent dans une nouvelle fenêtre
	//
	document.querySelectorAll('.wysiwyg a[target="_blank"]').forEach(function(link) {
		if(!link.hasAttribute('title')) {
			var regex = /^(www|http)/;

			if(regex.test(link.textContent)) {
				link.setAttribute('title', link.textContent + ' [nouvelle fenêtre]');
			} else {
				link.setAttribute('title', link.textContent.charAt(0).toUpperCase() + link.textContent.slice(1) + ' [nouvelle fenêtre]');
			}
		}
	});

	//
	// affichage du gestionnaire de consentement aux cookies et modification du positionnement du focus
	//
	document.querySelectorAll('.complianz > *, a.complianz').forEach((el) => {
		el.addEventListener('click', (event) => {
			event.preventDefault();

			cmplz_set_banner_status('');

			if(document.querySelector('.cmplz-categories-type-view-preferences').classList.contains('cmplz-categories-visible')) {
				document.querySelector('.cmplz-category.cmplz-functional > summary').focus();
			} else {
				document.querySelector('.cmplz-btn.cmplz-accept').focus();
			}
		});
	});

	if(document.querySelector('.cmplz-btn.cmplz-view-preferences')) {
		document.querySelector('.cmplz-btn.cmplz-view-preferences').addEventListener('click', function() {
			setTimeout(function() {
				document.querySelector('.cmplz-category.cmplz-functional > summary').focus();
			}, 100);
		});
	}

	//
	// modification de l'affichage du formulaire présent dans le gestionnaire de consentement aux cookies
	//
	document.querySelectorAll('#cmplz-cookiebanner-container .cmplz-close svg.fa-times').forEach(function(svg) {
		svg.setAttribute('height', '20');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container details:not(.cmplz-functional) .cmplz-banner-checkbox').forEach(function(banner) {
		banner.classList.add('d-flex', 'form-switch', 'lh-1');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container details:not(.cmplz-functional) .cmplz-banner-checkbox .cmplz-consent-checkbox').forEach(function(checkbox) {
		checkbox.classList.add('cursor-pointer', 'form-check-input', 'ms-0', 'mt-0');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container details:not(.cmplz-functional) .cmplz-banner-checkbox .cmplz-label span.screen-reader-text').forEach(function(span) {
		span.classList.remove('screen-reader-text');
		span.classList.add('visually-hidden');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container details:not(.cmplz-functional) .cmplz-banner-checkbox .cmplz-label').forEach(function(label) {
		label.removeAttribute('tabindex');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container details:not(.cmplz-functional) .cmplz-banner-checkbox').forEach(function(banner) {
		banner.classList.remove('cmplz-banner-checkbox');
	});

	//
	// transformation les liens ayant l'attribut role="link"
	//
	var links = document.querySelectorAll('[role="link"]');

	function dataToHref(link) {
		if(link.hasAttribute('data-href')) {
			link.setAttribute('href', link.getAttribute('data-href'));
			link.removeAttribute('data-href');
		}
	}

	links.forEach(function(link) {
		link.addEventListener('mouseover', function() {
			dataToHref(this);
		});

		link.addEventListener('focusin', function() {
			dataToHref(this);
		});

		link.addEventListener('click', function() {
			dataToHref(this);
		});
	});

	//
	// calcul de la taille de la scrollbar
	//
	function getScrollbarWidth() {
		let body			= document.querySelector('body');

		let div				= document.createElement('div');

		div.style.overflowY	= 'scroll';
		div.style.width		= '20px';
		div.style.height	= '20px';

		document.body.append(div);

		let scrollWidth		= div.offsetWidth - div.clientWidth;

		div.remove();

		for(let i = body.classList.length - 1; i >= 0; i--) {
			const className	= body.classList[i];
			if(className.startsWith('scrollbar-')) {
				body.classList.remove(className);
			}
		}

		if(scrollWidth == 0 || scrollWidth == 12 || scrollWidth == 15 || scrollWidth == 17) {
			body.classList.add('scrollbar-' + scrollWidth);
		}
	}

	getScrollbarWidth();

	addEventListener('resize', () => {
		getScrollbarWidth();
	});
}